import { render, staticRenderFns } from "./CopyObjectInstruction.vue?vue&type=template&id=7af6b881&"
import script from "./CopyObjectInstruction.vue?vue&type=script&lang=js&"
export * from "./CopyObjectInstruction.vue?vue&type=script&lang=js&"
import style0 from "./CopyObjectInstruction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports